var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"ratio-box",style:({
		width: _vm.cWidth,
		height: _vm.sizeVal(_vm.height),
		maxWidth: _vm.cMaxWidth,
		maxHeight: _vm.sizeVal(_vm.maxHeight),
	})},'div',_vm.$attrs,false),_vm.$listeners),[(!_vm.height && _vm.aspectRatio)?_c('div',{staticClass:"ratio-box__sizer",style:({ paddingBottom: ((100 / Number(_vm.aspectRatio)) + "%") })}):_vm._e(),_c('div',{staticClass:"ratio-box__slot"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }